import { Icon } from "../../../../components/BaseComponents/Icon";

export const ExpandMobileFiltersIcon = (props) => (
	<Icon viewBox={undefined} {...props}>
		<line x1="0" y1="0" x2="12" y2="0" stroke="currentColor" strokeWidth="4" />
		<line
			x1="2"
			y1="6"
			x2="10.5"
			y2="6"
			stroke="currentColor"
			strokeWidth="2"
		/>
		<line
			x1="4.5"
			y1="10.5"
			x2="8.5"
			y2="10.5"
			stroke="currentColor"
			strokeWidth="2"
		/>
	</Icon>
);
